export const goToPreviousMonthStringLowerCaseText = "tU4C0b";
export const goToNextMonthStringLowerCaseText = "z$fIq";
export const goToPreviousYearStringLowerCaseText = "wWoad";
export const goToNextYearStringLowerCaseText = "_jI1Gc";
export const goToPreviousYearRangeStringLowerCaseText = "bzXECd";
export const goToNextYearRangeStringLowerCaseText = "z$RCib";
export const calendarDayOfWeek_Su = "SsSend";
export const calendarDayOfWeek_Mo = "Yz6cnd";
export const calendarDayOfWeek_Tu = "Hr$end";
export const calendarDayOfWeek_We = "Mn4fnd";
export const calendarDayOfWeek_Th = "ur$end";
export const calendarDayOfWeek_Fr = "wI1and";
export const calendarDayOfWeek_Sa = "ysSend";
export const monthPickerHeaderAriaLabel = "sDAAKd";
export const yearPickerHeaderAriaLabel = "xAyPK";
export const weekNumberFormatString = "dJqiW";
export const selectedDateFormatString = "xhsKkc";
export const todayDateFormatString = "rzacbd";
export const dayMarkedAriaLabel = "D5khFb";
export const isResetStatusMessage = "IfCMzd";
export default {goToPreviousMonthStringLowerCaseText,goToNextMonthStringLowerCaseText,goToPreviousYearStringLowerCaseText,goToNextYearStringLowerCaseText,goToPreviousYearRangeStringLowerCaseText,goToNextYearRangeStringLowerCaseText,calendarDayOfWeek_Su,calendarDayOfWeek_Mo,calendarDayOfWeek_Tu,calendarDayOfWeek_We,calendarDayOfWeek_Th,calendarDayOfWeek_Fr,calendarDayOfWeek_Sa,monthPickerHeaderAriaLabel,yearPickerHeaderAriaLabel,weekNumberFormatString,selectedDateFormatString,todayDateFormatString,dayMarkedAriaLabel,isResetStatusMessage};